import { useQuery } from "react-query";
import { TenantTreeResponse } from "./../typings/tenant";
import http from "infra/http";

function useCondominiosLiberados(tenant: string, cb?: any) {
  return useQuery("/v1/permissao", async () => {
    const res = await http.get<TenantTreeResponse[]>("/v1/tenants/tree", {
      headers: { tenant },
    });

    return res.data;
  });
}

export default useCondominiosLiberados;
